import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import { _hasPermission	} from "../../../shared/helpers/access";

let rows = [
 
  {
    id: 'name', disablePadding: true, label: 'Building Name',
  },
  {
    id: 'inventory_pct_unsold', disablePadding: false, label: '% Unsold',
  },
   {
    id: 'inventory_unsold', disablePadding: false, label: 'Unsold',
  },
  {
    id: 'inventory_total', disablePadding: false, label: '# of Units',
  },
  {
    id: 'year_built', disablePadding: false, label: 'Year Built',
  },
  {
    id: 'offering_submitted_date', disablePadding: false, label: 'OP Submitted',
  },
  {
    id: 'offering_accepted_date', disablePadding: false, label: 'OP Accepted',
  },
  {
    id: 'sales_start_date', disablePadding: false, label: 'Sales Started',
  },
  {
    id: 'building_effective_start', disablePadding: false, label: 'CO/TCO Issued',
  },
  {
    id: 'inventory_stats_listings_low_price', disablePadding: false, label: 'Price Range',
  },
  {
    id: 'offering_verified_status', disablePadding: false, admin_only:true, label: 'Status',
  }
 
];

let rowsResale = [
 
  {
    id: 'name', disablePadding: true, label: 'Building Name',
  },
 
  {
    id: 'inventory_total', disablePadding: false, label: '# of Units',
  },
  {
    id: 'year_built', disablePadding: false, label: 'Year Built',
  },
  {
    id: 'offering_submitted_date', disablePadding: false, label: 'OP Submitted',
  },
  {
    id: 'offering_accepted_date', disablePadding: false, label: 'OP Accepted',
  },
 
  {
    id: 'inventory_stats_listings_low_price', disablePadding: false, label: 'Price Range',
  },
  {
    id: 'offering_verified_status', disablePadding: false, admin_only:true, label: 'Status',
  }
 
];
class MatTableHead extends PureComponent {
  static propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    rtl: RTLProps.isRequired,
  };

  createSortHandler = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick, order, orderBy, numSelected, rowCount, rtl, user
    } = this.props;
    
    if(!_hasPermission(user, 'sponsor-buildings')){
      rows = rowsResale;
    }
    rows = (user && user.role.indexOf('admin')>=0) ?  rows : rows.filter(item => !item.admin_only)

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              className={`material-table__checkbox ${numSelected === rowCount && 'material-table__checkbox--checked'}`}
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={() => onSelectAllClick('buildings')}
            />
          </TableCell>
          {rows.map(row => (
            <TableCell
              className="material-table__cell material-table__cell--sort material-table__cell-right"
              key={row.id}
              align={rtl.direction === 'rtl' ? 'right' : 'left'}
              padding={row.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === row.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={this.createSortHandler(row.id)}
                className="material-table__sort-label"
                dir="ltr"
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
          ), this)}
        </TableRow>
      </TableHead>
    );
  }
}

export default connect(state => ({
  rtl: state.rtl,
  user: state.user
}))(MatTableHead);
